import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom"; 
import swal from "sweetalert2";

const Stock = () => {
    const [Checked, checkIsChecked] = useState(false);
    const [stockData, setStockData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const handleCheckboxChange = () => {
        checkIsChecked(!Checked);
    }; 

    const fetchStockData = async () => {
        try {
            const params = new URLSearchParams({
                page,
                per_page: perPage,
                search: searchTerm
            });
            const response = await fetch(`${baseURL}/purchases-checklist?${params.toString()}`);
            const data = await response.json();

            if (data.data) {
                setStockData(data.data);
                setTotalPages(data.total_pages || 1);
                setTotalEntries(data.total_items || 0);
            }
        } catch (error) {
            console.error("Error fetching stock data:", error);
            swal.fire("Error", "Failed to fetch stock data", "error");
        }
    };

    useEffect(() => {
        fetchStockData();
    }, [page, perPage, searchTerm]);

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Stock Checklist</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Purchase Management</li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Manage Stock</li>
                    </ol>
                </div>
            </div>

            <div>
                <div className='text-danger fs-3 font-w500 text-center mb-3'>Stock Consumption Verification</div>

                 

                <div className="table-container">
                     <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{  fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1); // Reset to first page
                                }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <input
                                type="text"
                                style={{  fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1); // Reset page on new search
                                }}
                            />
                        </div>
                    </div>

                    <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='min-w-10px'>
                                    <input
                                        type="checkbox"
                                        onChange={handleCheckboxChange}
                                        className="form-check-input me-3"
                                        id="customCheckBox1"
                                    />
                                </th>
                                <th className='min-w-150px'>Raw Material</th>
                                <th className='min-w-100px'>Purchased Stock</th>
                                <th className='min-w-120px text-center'>Storage/Kitchen Room</th>
                                <th className='min-w-100px text-center'>Consumed Stock</th>
                                <th className='min-w-100px text-center'>Wasted Stock</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {stockData.length > 0 ? (
                                stockData.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                onChange={handleCheckboxChange}
                                                className="form-check-input me-3"
                                                id={`customCheckBox_${index}`}
                                            />
                                        </td> 
                                        <td>
                                            {/* {item.image_url && (
                                                <img 
                                                    src={item.image_url} 
                                                    alt={item.raw_material_name} 
                                                    style={{ width: '40px', height: '40px', marginRight: '8px', verticalAlign: 'middle' }}
                                                />
                                            )} */}
                                            <label className='text-black font-w400 fs-6'>
                                                {item.raw_material_name}
                                            </label>
                                            <br />
                                            <label className='text-black font-w400 fs-7'>
                                                {new Date(item.purchase_date).toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric'
                                                })}
                                            </label>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-5 text-center'>
                                                {item.purchased_quantity} {item.purchased_unit}
                                            </label>
                                        </td>
                                        <td className='text-center'>
                                            <label className='text-primary font-w400 fs-5'>
                                                {item.current_stock} {item.current_stock_unit}
                                            </label> / 
                                            <label className='text-info font-w400 fs-5'>
                                                {item.kitchen_stock_quantity} {item.kitchen_stock_unit}
                                            </label>
                                        </td>
                                        <td className='text-center'>
                                            <label className='text-black font-w400 fs-5'>
                                                {item.kitchen_consumed_quantity} {item.kitchen_consumed_unit}
                                            </label>
                                        </td>
                                        <td className='text-center'>
                                            <label className='text-danger font-w400 fs-5'>
                                                {item.total_wastage_quantity && item.wastage_unit
                                                    ? `${item.total_wastage_quantity} ${item.wastage_unit}`
                                                    : "-"}
                                            </label>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted">
                                        No records found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                         <div className="d-flex justify-content-between align-items-center mt-3">
                            {/* Bottom left: Showing x to y of z entries */}
                            <div>
                                {stockData.length > 0 ? (
                                    <span className="text-muted">
                                        Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + stockData.length} of {totalEntries} entries
                                    </span>
                                ):(
                                    <span className="text-muted">
                                        Showing 0 to 0 of 0 entries
                                    </span>
                                )}
                            </div>

                            {/* Bottom right: Pagination */}
                            <nav>
                                <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                    {/* Previous Button */}
                                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                            Previous
                                        </button>
                                    </li>

                                    {/* First Page */}
                                    <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                            1
                                        </button>
                                    </li>

                                    {/* Left Ellipsis */}
                                    {page > 4 && (
                                        <li className="page-item disabled">
                                            <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                        </li>
                                    )}

                                    {/* Pages Around Current */}
                                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                                        .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                        .map(p => (
                                            <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                    {p}
                                                </button>
                                            </li>
                                        ))
                                    }

                                    {/* Right Ellipsis */}
                                    {page < totalPages - 3 && (
                                        <li className="page-item disabled">
                                            <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                        </li>
                                    )}

                                    {/* Last Page */}
                                    {totalPages > 1 && (
                                        <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                            {totalPages}
                                            </button>
                                        </li>
                                    )}

                                    {/* Next Button */}
                                    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                </div>
            </div>
        </>
    )
}

export default Stock;
